import $ from 'jquery';
import { nanoid } from 'nanoid';
import Foundation from './3rd/_zf';
import select2 from 'select2';

select2();

import BackToTop from './components/back-to-top';
import { initMenu } from './components/menu.js';
import scriptLoader from './components/script-loader';
import { initSocialShare } from './components/social-share';
import SimpleBar from 'simplebar';
import ResizeObserver from 'resize-observer-polyfill';
import { Fancybox } from '@fancyapps/ui';

window.ResizeObserver = ResizeObserver;

// Styles
import '../sass/3rd/_index.scss';
import 'simplebar/dist/simplebar.css';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

/** video.js */
// import videojs from "!video.js";
// import videojs_youtube from "videojs-youtube/dist/Youtube.min";

//------------------------------------

Fancybox.bind('.fcy_popup, .fcy_video, .banner_video a', {});
Fancybox.bind('.wp_block_gallery .wp_block_image a, [id^="gallery-"] a, [data-rel="lightbox"]', {
    groupAll: true, // Group all items
});
Fancybox.bind('.fcy_album_combo, .fcy_album_imageshome ', {
    groupAll: true, // Group all items
});
Fancybox.bind('[data-fancybox]', {});


// Global variables
const hdDefaults = {
    _ajaxUrl: '/wp-admin/admin-ajax.php',
    _baseUrl: 'http://localhost:8080/',
    _themeUrl: 'http://localhost:8080/wp-content/themes/hd/',
    _csrfToken: '***',
    _restToken: '***',
    _lang: 'vi',
};

const {
    _ajaxUrl: ajaxUrl,
    _baseUrl: baseUrl,
    _themeUrl: themeUrl,
    _csrfToken: csrfToken,
    _restToken: restToken,
    _lang: lang,
} = { ...hdDefaults, ...(typeof hd !== 'undefined' ? hd : {}) };

// DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
    new BackToTop();
    initMenu('nav.nav', '.main-nav');
    scriptLoader(4000, 'script[data-type=\'lazy\']');
    initSocialShare('[data-social-share]', { intents: [ 'facebook', 'x', 'print', 'send-email', 'copy-link', 'web-share' ] });

    // auto rel
    document.querySelectorAll('a._blank, a.blank, a[target="_blank"]').forEach((el) => {
        if (!el.hasAttribute('target') || el.getAttribute('target') !== '_blank') {
            el.setAttribute('target', '_blank');
        }

        const relValue = el?.getAttribute('rel');
        if (!relValue || !relValue.includes('noopener') || !relValue.includes('nofollow')) {
            const newRelValue = (relValue ? relValue + ' ' : '') + 'noopener noreferrer nofollow';
            el.setAttribute('rel', newRelValue);
        }
    });

    // fancybox popup
    $('.fixed_popup').on('click', function (e) {
        e.preventDefault();
        Fancybox.show([{src: '#form_popup', type: 'inline'}]);
    });

    $(document).ready(function(){
        $('.list_contacts').click(function(){
            $(this).closest('.hb_fixed_lists ul').toggleClass('open');
        });
    });

    // Gộp class trang archive post
    $( ".section-page.archive .flex-info .contents .archive-list .cell.add" ).wrapAll( "<div class='container box_2' />");

    //Kích hoạt Select2
    // $(document).ready(function() {
    //     $('#area').select2();
    //     $('#alternative').select2();
    //     $('#customer').select2();
    // });

    // toggle menu footer
    // document.querySelectorAll(".site-footer .footer-title").forEach(link => {
    //     link.addEventListener("click", function (event) {
    //         event.preventDefault();
    //         this.classList.toggle("active");
    //     });
    // });

    /** */
    //let product_desc = $('.product-desc-inner');
    // product_desc.each((index, el) => {
    //     const _rand = nanoid(8);
    //     $(el).attr('id', 'desc_' + _rand);

    //     let _height = $(el).outerHeight(false);
    //     if (_height > 1100) {
    //         $(el).css({'height':'465','transition':'0.3s'});
            
    //         // Lấy text từ attribute data-view-more-text
    //         const viewMoreText = $('#product-description-container').data('view-more-text');


    //         let _viewmore_html = '<div class="viewmore-wrappers"><a class="btn-viewmore" title="' + viewMoreText + '" data-src="#desc_' + _rand + '" data-modal="false" href="javascript:;" data-glyph-after="">' + viewMoreText + '</a></div>';
    //         $(el).append(_viewmore_html);

    //         $("#desc_" + _rand).find('.btn-viewmore').on('click', function (e) {
    //             e.preventDefault();

    //             //$(el).addClass('is-open');
    //             $(el).css({'height':'auto','transition':'0.3s'});
    //             $("#desc_" + _rand).find('.viewmore-wrappers').fadeOut();
    //         })

    //         //Fancybox.bind("#desc-inner .btn-viewmore", {});
    //     }
    // });

    //...


    //...
    const _qty_controls = () => {

        /**qty*/
        $('.input-number-increment').off('click').on('click', function (e) {
            e.preventDefault();
            let $input = $(this).parents('.input-number-group').find('.qty');
            let val = parseInt($input.val(), 10);
            $input.val(val + 1);

            let update_cart = $('button[name="update_cart"]');
            if (update_cart.length > 0) {
                update_cart.prop('disabled', false)
            }
        });

        $('.input-number-decrement').off('click').on('click', function (e) {
            e.preventDefault();
            let $input = $(this).parents('.input-number-group').find('.qty');
            let val = parseInt($input.val(), 10);
            if (val > 1) {
                $input.val(val - 1);

                let update_cart = $('button[name="update_cart"]');
                if (update_cart.length > 0) {
                    update_cart.prop('disabled', false)
                }
            }
        });
    }

    // run
    _qty_controls();

    /** ajaxComplete */
    $( document ).ajaxComplete(function( event, xhr, settings ) {
        _qty_controls();
    });

    // tabs
    var tabLinks = document.querySelectorAll(".tablinks");
    var tabContent = document.querySelectorAll(".tabcontent");

    tabLinks.forEach(function(el) {
        el.addEventListener("click", openTabs);
    });

    function openTabs(el) {
        var btnTarget = el.currentTarget;
        var country = btnTarget.dataset.country;

        tabContent.forEach(function(el) {
            el.classList.remove("active");
        });

        tabLinks.forEach(function(el) {
            el.classList.remove("active");
        });

        document.querySelector("#" + country).classList.add("active");
        btnTarget.classList.add("active");
    }

    // 👉 Kích hoạt tab đầu tiên mặc định khi trang load
    if (tabLinks.length > 0) {
        tabLinks[0].classList.add("active");
        var firstCountry = tabLinks[0].dataset.country;
        var firstTabContent = document.querySelector("#" + firstCountry);
        if (firstTabContent) {
            firstTabContent.classList.add("active");
        }
    }

    // MutationObserver
    const observer = new MutationObserver(() => {
        document.querySelectorAll('ul.sub-menu[role="menubar"]').forEach(menu => {
            menu.setAttribute('role', 'menu');
        });

        document.querySelectorAll('[aria-hidden="true"] a, [aria-hidden="true"] button').forEach(el => {
            el.setAttribute('tabindex', '-1');
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
        
});
